module.exports = __webpack_public_path__ + "img/card6-bl3.ec176624.svg";